// extracted by mini-css-extract-plugin
export default {"shell-placeholder":"g__shell-placeholder--EzynU","shell-spinner":"g__shell-spinner--RcNMd","shell-spin":"g__shell-spin--xXu5y","shell-sr-only":"g__shell-sr-only--DQ1jl"};